import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Search, Button, Form as FormUi } from "semantic-ui-react";
import { translate } from "react-i18next";
import { Formik, Field as Fieldmik } from "formik";
import { DateData } from "../dynamicComponent/datepick";
import moment from "moment";

import { connect } from "react-redux";
import allAxiosCommonTA from "../axiosComponent/allAxiosCommonTA";

const FilterHeader = (props) => {
  const { t } = props;

  const initialValues = {
    billStartDate: "",
    billEndDate: "",
  };


  useEffect(() => {
    console.log(props.userStatistic)
  }, [props.userStatistic]);

  return (
    <React.Fragment>
      <div>
        <div className="container-fluid dip_bar">
          <div className="row">
            
            <div className="col-sm-12 display-flex-center-justify-center">
              <div className="form-inline">
                <Button
                  type="button"
                  basic
                  color="green"
                  size="mini"
                // className="w3-blue w3-round w3-hover-blue"
                >
                  {"Created "}
                  {props.userStatistic.created}
                </Button>
                <Button
                  type="button"
                  basic
                  color="yellow"
                  size="mini"
                // className="w3-blue w3-round w3-hover-blue"
                >
                  {"In Progress "}
                  {props.userStatistic.in_progress}
                </Button>
                <Button
                  type="button"
                  basic
                  color="green"
                  size="mini"
                  className="w3-blue w3-round w3-hover-blue"
                >
                  {"Received "}
                  {props.userStatistic.received}
                </Button>
                <Button
                  type="button"
                  basic
                  color="red"
                  size="mini"
                  className="w3-blue w3-round w3-hover-blue"
                >
                  {"Rejected "}
                  {props.userStatistic.rejected}
                </Button>
                <Button
                  type="button"
                  basic
                  color="green"
                  size="mini"
                // className="w3-blue w3-round w3-hover-blue"
                >
                  {"Completed "}
                  {props.userStatistic.completed}
                </Button>
                <Button
                  type="button"
                  basic
                  color="red"
                  size="mini"
                  className="w3-blue w3-round w3-hover-blue"
                >
                  {"Cancelled "}
                  {props.userStatistic.cancelled}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  };
};
export default connect(mapStateToProps)(translate("orders")(FilterHeader));
